import type { CSSProperties } from 'react'

import { cn } from '../../../../lib/utils'

type GradientOrbProps = {
  /** Diameter in CSS pixels. Blur radii scale with it. */
  size?: number
  className?: string
}

/**
 * RFC-1612 download-preparing indicator: the animated indigo/orange orb from
 * the design reference, drawn in CSS (`.dw-gradient-orb` in globals.css) so no
 * video asset ships with the console. Decorative only; the caller carries the
 * accessible status text.
 */
export function GradientOrb({ size = 16, className }: GradientOrbProps) {
  const style: CSSProperties & Record<'--orb-size', string> = {
    width: size,
    height: size,
    '--orb-size': `${size}px`,
  }
  return (
    <span
      aria-hidden="true"
      className={cn('dw-gradient-orb', className)}
      style={style}
      data-testid="gradient-orb"
    />
  )
}
